export default [
  {
    'text': 'success',
    'state': 'RUNNING'
  },
  {
    'text': 'warning',
    'state': 'MAINTENANCE'
  },
  {
    'text': 'error',
    'state': 'CLOSED'
  },
];



// WEBPACK FOOTER //
// ./src/api/serverStateColor.js